import React, { useMemo } from 'react';
import { InlineAlert } from '@xo-union/tk-component-alerts';
import { DisplayButton } from '@xo-union/tk-ui-links';
import styles from './styles.scss';

interface Props {
  isPrivateRsvp: boolean;
  rsvpPageHidden: boolean;
  onClick: () => void;
}

const getRsvpCopy = (rsvpPageHidden: boolean, isPrivateRsvp: boolean): string => {
  let rsvpState;
  if (rsvpPageHidden && isPrivateRsvp) {
    rsvpState = "Guests can't RSVP yet.";
  } else if (rsvpPageHidden && !isPrivateRsvp) {
    rsvpState = 'Nobody can RSVP yet.';
  } else if (!rsvpPageHidden && isPrivateRsvp) {
    rsvpState = 'Guests on your Guest List can RSVP.';
  } else {
    rsvpState = 'Anyone with the link can RSVP.';
  }

  return rsvpState;
};

const RsvpHiddenMessage: React.FunctionComponent<Props> = ({ isPrivateRsvp, rsvpPageHidden, onClick }) => {
  const rsvpCopy = useMemo(() => getRsvpCopy(rsvpPageHidden, isPrivateRsvp), [rsvpPageHidden, isPrivateRsvp]);

  return (
    <InlineAlert type="info" icon={rsvpPageHidden ? 'eye_closed' : 'eye'} className={styles.inlineAlert}>
      <span className={styles.message} data-testid="rsvp-hidden-message">
        This form is <b>{rsvpPageHidden ? 'hidden' : 'visible'}</b> on your Website. {rsvpCopy}
      </span>
      <DisplayButton target="_blank" rel="noopener noreferrer" onClick={onClick} className={styles.displayLink}>
        View Settings
      </DisplayButton>
    </InlineAlert>
  );
};

export default RsvpHiddenMessage;
